const ARC_1_ACT_2_CUT_SCENE = {
  id: "arc-1-act-2",
  cover: null,
  pages: [
    {
      id: "act-2-page-1",
      title: "Grand Council",
      pageLabel: "001",
      frames: [
        {
          id: "act-2-page-1-three-bottom-wide-row-flip-panel-1",
          area: "7 / 1 / 13 / 4",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page1-panel1.png?alt=media&token=5bef1f10-c704-4e07-be65-5b069442f9ad",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page1-panel1.png?alt=media&token=5bef1f10-c704-4e07-be65-5b069442f9ad",
          alt: "Bottom Wide Reveal Row Flip panel 1",
          overlayText: "And among dragons, there is an ancient law...",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 76,
            topPercent: 78,
            leftPercent: 22,
            fontSizeCqw: 5.5,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-1-three-bottom-wide-row-flip-panel-1-beat-1",
              text: "And among dragons, there is an ancient law...",
              speaker: null,
            },
          ],
        },
        {
          id: "act-2-page-1-three-bottom-wide-row-flip-panel-2",
          area: "7 / 4 / 13 / 7",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page1-panel2.png?alt=media&token=86e28d35-463f-417e-b4cd-0ece7d26e969",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page1-panel2.png?alt=media&token=86e28d35-463f-417e-b4cd-0ece7d26e969",
          alt: "Bottom Wide Reveal Row Flip panel 2",
          overlayText: "Any treasure discovered while protecting the realm belongs to the dragon who found it.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 86,
            topPercent: 4,
            leftPercent: -2,
            fontSizeCqw: 5,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-1-three-bottom-wide-row-flip-panel-2-beat-1",
              text: "Any treasure discovered while protecting the realm belongs to the dragon who found it.",
              speaker: null,
            },
          ],
        },
        {
          id: "act-2-page-1-three-bottom-wide-row-flip-panel-3",
          area: "1 / 1 / 7 / 7",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page1-panel3.png?alt=media&token=befce713-a490-4826-904e-d9b64ee2c8fb",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page1-panel3.png?alt=media&token=befce713-a490-4826-904e-d9b64ee2c8fb",
          alt: "Bottom Wide Reveal Row Flip panel 3",
          overlayText: "The Council protected our realm from Rift breaches, void storms... things most citizens never even knew existed.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 96.5,
            topPercent: 83,
            leftPercent: 0,
            fontSizeCqw: 3,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-1-three-bottom-wide-row-flip-panel-3-beat-1",
              text: "The Council protected our realm from Rift breaches, void storms... things most citizens never even knew existed.",
              speaker: null,
            },
          ],
        },
      ],
      layoutPresetId: "three-bottom-wide-row-flip",
    },
    {
      id: "act-2-page-2",
      title: "Runelord's Find",
      pageLabel: "002",
      frames: [
        {
          id: "act-2-page-2-four-sandwich-panel-1",
          area: "1 / 1 / 4 / 7",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page2-panel1.png?alt=media&token=dc59c6f2-357d-4768-b554-8b7dd497631b",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page2-panel1.png?alt=media&token=dc59c6f2-357d-4768-b554-8b7dd497631b",
          alt: "Sandwich Four panel 1",
          overlayText: "Runelord discovered the Rune Stone during a Rift expedition.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 45,
            topPercent: -9,
            leftPercent: 53,
            fontSizeCqw: 2.4,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-2-four-sandwich-panel-1-beat-1",
              text: "Runelord discovered the Rune Stone during a Rift expedition.",
              speaker: null,
            },
          ],
        },
        {
          id: "act-2-page-2-four-sandwich-panel-2",
          area: "4 / 1 / 8 / 4",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page2-panel2.png?alt=media&token=aa9f6c3a-65ef-4a64-928f-323bd9bde03f",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page2-panel2.png?alt=media&token=aa9f6c3a-65ef-4a64-928f-323bd9bde03f",
          alt: "Sandwich Four panel 2",
          overlayText: "At first... it seemed like a miracle.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 70,
            topPercent: -3,
            leftPercent: 6,
            fontSizeCqw: 4.4,
            rotationDeg: 0,
          },
          hideExpandedText: true,
          script: [
            {
              id: "act-2-page-2-four-sandwich-panel-2-beat-1",
              text: "At first... it seemed like a miracle.",
              speaker: null,
            },
          ],
        },
        {
          id: "act-2-page-2-four-sandwich-panel-3",
          area: "4 / 4 / 8 / 7",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page2-panel3.png?alt=media&token=9150daa9-fbbf-4764-9b34-5bff2720a386",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page2-panel3.png?alt=media&token=9150daa9-fbbf-4764-9b34-5bff2720a386",
          alt: "Sandwich Four panel 3",
          overlayText: "The Rune amplified his power. Strengthened his spells. Even stabilized parts of the Rift.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 75,
            topPercent: 67,
            leftPercent: -5,
            fontSizeCqw: 4.4,
            rotationDeg: 0,
          },
          hideExpandedText: true,
          script: [
            {
              id: "act-2-page-2-four-sandwich-panel-3-beat-1",
              text: "The Rune amplified his power. Strengthened his spells. Even stabilized parts of the Rift.",
              speaker: null,
            },
          ],
        },
        {
          id: "act-2-page-2-four-sandwich-panel-4",
          area: "8 / 1 / 13 / 7",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page2-panel4.png?alt=media&token=f0112c8d-fd6c-45ad-9742-4bfa43008a01",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page2-panel4.png?alt=media&token=f0112c8d-fd6c-45ad-9742-4bfa43008a01",
          alt: "Sandwich Four panel 4",
          overlayText: "The Council praised him for it.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 96.4,
            topPercent: 86,
            leftPercent: 0,
            fontSizeCqw: 4,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-2-four-sandwich-panel-4-beat-1",
              text: "The Council praised him for it.",
              speaker: null,
            },
          ],
        },
      ],
      layoutPresetId: "four-sandwich",
    },
    {
      id: "act-2-page-3",
      title: "The Corruption",
      pageLabel: "003",
      frames: [
        {
          id: "act-2-page-3-five-bottom-strip-panel-1",
          area: "1 / 1 / 8 / 4",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page3-panel1.png?alt=media&token=2c6eae4e-d28d-411d-95cc-caa33fbf5559",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page3-panel1.png?alt=media&token=2c6eae4e-d28d-411d-95cc-caa33fbf5559",
          alt: "Bottom Strip Five panel 1",
          overlayText: "But then he started changing.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 70,
            topPercent: 6,
            leftPercent: -3,
            fontSizeCqw: 4.4,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-3-five-bottom-strip-panel-1-beat-1",
              text: "But then he started changing.",
              speaker: null,
            },
          ],
        },
        {
          id: "act-2-page-3-five-bottom-strip-panel-2",
          area: "1 / 4 / 8 / 7",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page3-panel2.png?alt=media&token=0916d12e-bb95-4cf8-afd3-fa108f6cb12f",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page3-panel2.png?alt=media&token=0916d12e-bb95-4cf8-afd3-fa108f6cb12f",
          alt: "Bottom Strip Five panel 2",
          overlayText: "His temper grew worse. His body began absorbing void energy. He became obsessed with the Rune.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 80,
            topPercent: 82,
            leftPercent: 6,
            fontSizeCqw: 4.4,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-3-five-bottom-strip-panel-2-beat-1",
              text: "His temper grew worse. His body began absorbing void energy. He became obsessed with the Rune.",
              speaker: null,
            },
          ],
        },
        {
          id: "act-2-page-3-five-bottom-strip-panel-3",
          area: "8 / 1 / 13 / 3",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page3-panel3.png?alt=media&token=8cd343d6-aace-4b22-b765-b9ef28036300",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page3-panel3.png?alt=media&token=8cd343d6-aace-4b22-b765-b9ef28036300",
          alt: "Bottom Strip Five panel 3",
          overlayText: "I tried to warn the others, but nobody listened.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 78,
            topPercent: 2,
            leftPercent: 6,
            fontSizeCqw: 5.4,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-3-five-bottom-strip-panel-3-beat-1",
              text: "I tried to warn the others, but nobody listened.",
              speaker: null,
            },
          ],
        },
        {
          id: "act-2-page-3-five-bottom-strip-panel-4",
          area: "8 / 3 / 13 / 5",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page3-panel4.png?alt=media&token=25cef747-0558-4734-b344-a4e517e3e2f4",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page3-panel4.png?alt=media&token=25cef747-0558-4734-b344-a4e517e3e2f4",
          alt: "Bottom Strip Five panel 4",
          overlayText: "They said the treasure belonged to him by right.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 77,
            topPercent: 80,
            leftPercent: -3,
            fontSizeCqw: 5.4,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-3-five-bottom-strip-panel-4-beat-1",
              text: "They said the treasure belonged to him by right.",
              speaker: null,
            },
          ],
        },
        {
          id: "act-2-page-3-five-bottom-strip-panel-5",
          area: "8 / 5 / 13 / 7",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page3-panel5.png?alt=media&token=9be4c232-107a-4343-89f1-029e3e24e306",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page3-panel5.png?alt=media&token=9be4c232-107a-4343-89f1-029e3e24e306",
          alt: "Bottom Strip Five panel 5",
          overlayText: "That questioning him would dishonor the Council.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 83,
            topPercent: -1,
            leftPercent: 8,
            fontSizeCqw: 5.4,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-3-five-bottom-strip-panel-5-beat-1",
              text: "That questioning him would dishonor the Council.",
              speaker: null,
            },
          ],
        },
      ],
      layoutPresetId: "five-bottom-strip",
    },
    {
      id: "act-2-page-4",
      title: "The Fracture",
      pageLabel: "004",
      frames: [
        {
          id: "act-2-page-4-four-grid-panel-1",
          area: "1 / 1 / 7 / 4",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page4-panel1.png?alt=media&token=00167d2a-2656-4149-b9a8-3ecedde13f2c",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page4-panel1.png?alt=media&token=00167d2a-2656-4149-b9a8-3ecedde13f2c",
          alt: "Four Grid panel 1",
          overlayText: "By the time they realized I was right... it was already too late.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 75,
            topPercent: 45,
            leftPercent: 9,
            fontSizeCqw: 4.4,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-4-four-grid-panel-1-beat-1",
              text: "By the time they realized I was right... it was already too late.",
              speaker: null,
            },
          ],
        },
        {
          id: "act-2-page-4-four-grid-panel-2",
          area: "1 / 4 / 7 / 7",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page4-panel2.png?alt=media&token=748c13dc-a9dc-4673-9d89-5a3741b3df6b",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page4-panel2.png?alt=media&token=748c13dc-a9dc-4673-9d89-5a3741b3df6b",
          alt: "Four Grid panel 2",
          overlayText: "Runelord changed completely.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 46,
            topPercent: -2,
            leftPercent: 52,
            fontSizeCqw: 4.4,
            rotationDeg: 5,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-4-four-grid-panel-2-beat-1",
              text: "Runelord changed completely.",
              speaker: null,
            },
          ],
        },
        {
          id: "act-2-page-4-four-grid-panel-3",
          area: "7 / 1 / 13 / 4",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page4-panel3.png?alt=media&token=aa51ec7f-1bdc-46d1-9f78-b5688e3839c1",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page4-panel3.png?alt=media&token=aa51ec7f-1bdc-46d1-9f78-b5688e3839c1",
          alt: "Four Grid panel 3",
          overlayText: "Cryptor sided with him.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 59,
            topPercent: 0,
            leftPercent: 0,
            fontSizeCqw: 4.4,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-4-four-grid-panel-3-beat-1",
              text: "Cryptor sided with him.",
              speaker: null,
            },
          ],
        },
        {
          id: "act-2-page-4-four-grid-panel-4",
          area: "7 / 4 / 13 / 7",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page4-panel4.png?alt=media&token=409de2bd-1960-49c1-a578-bd3dfd59ddaa",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page4-panel4.png?alt=media&token=409de2bd-1960-49c1-a578-bd3dfd59ddaa",
          alt: "Four Grid panel 4",
          overlayText: "Zaporia and Zora tried to stop them... but they were captured when the Rift fractured open.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 86,
            topPercent: 80,
            leftPercent: -4,
            fontSizeCqw: 4,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "act-2-page-4-four-grid-panel-4-beat-1",
              text: "Zaporia and Zora tried to stop them... but they were captured when the Rift fractured open.",
              speaker: null,
            },
          ],
        },
      ],
      layoutPresetId: "four-grid",
    },
    {
      id: "arc-1-act-2-page-5",
      pageLabel: "005",
      frames: [
        {
          id: "arc-1-act-2-page-5-two-cinema-row-flip-panel-1",
          area: "6 / 1 / 13 / 7",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page5-panel1.png?alt=media&token=07e5fc8b-eb72-443d-8e6f-0552f929d312",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page5-panel1.png?alt=media&token=07e5fc8b-eb72-443d-8e6f-0552f929d312",
          alt: "Cinema Split Row Flip panel 1",
          overlayText: "Runelord. Cryptor. Zora. Zaporia...",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 88,
            topPercent: 90,
            leftPercent: 4,
            fontSizeCqw: 4.65,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "arc-1-act-2-page-5-two-cinema-row-flip-panel-1-beat-1",
              text: "Runelord. Cryptor. Zora. Zaporia...",
              speaker: null,
            },
          ],
        },
        {
          id: "arc-1-act-2-page-5-two-cinema-row-flip-panel-2",
          area: "1 / 1 / 6 / 7",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page5-panel2.png?alt=media&token=4f6ab62f-25d0-4699-bd38-0073747447e9",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page5-panel2.png?alt=media&token=4f6ab62f-25d0-4699-bd38-0073747447e9",
          alt: "Cinema Split Row Flip panel 2",
          overlayText: "When the Rift catastrophe happened... I thought they were gone.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 93,
            topPercent: 2,
            leftPercent: 1,
            fontSizeCqw: 3.25,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "arc-1-act-2-page-5-two-cinema-row-flip-panel-2-beat-1",
              text: "When the Rift catastrophe happened... I thought they were gone.",
              speaker: null,
            },
          ],
        },
      ],
      title: "THE COLLAPSE",
      layoutPresetId: "two-cinema-row-flip",
    },
    {
      id: "arc-1-act-2-page-6",
      pageLabel: "006",
      frames: [
        {
          id: "arc-1-act-2-page-6-two-vertical-panel-1",
          area: "1 / 1 / 13 / 4",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page6-panel1.png?alt=media&token=38950085-d3cb-42e9-b9ff-54d810bf9980",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page6-panel1.png?alt=media&token=38950085-d3cb-42e9-b9ff-54d810bf9980",
          alt: "Dual Splash panel 1",
          overlayText: "The entire Council vanished into the collapse.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 86,
            topPercent: 2,
            leftPercent: 12,
            fontSizeCqw: 5.4,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "arc-1-act-2-page-6-two-vertical-panel-1-beat-1",
              text: "The entire Council vanished into the collapse.",
              speaker: null,
            },
          ],
        },
        {
          id: "arc-1-act-2-page-6-two-vertical-panel-2",
          area: "1 / 4 / 13 / 7",
          image: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page6-panel2.png?alt=media&token=ca5effd6-c872-4503-b8c1-73934ba1b1f7",
          thumbnail: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Farc-1%2Fact-2%2Farc1-act2-page6-panel2.png?alt=media&token=ca5effd6-c872-4503-b8c1-73934ba1b1f7",
          alt: "Dual Splash panel 2",
          overlayText: "I barely escaped with the Rune Stone.",
          overlayBox: {
            enabled: true,
            theme: "light",
            widthPercent: 70,
            topPercent: 90,
            leftPercent: -6,
            fontSizeCqw: 5.4,
            rotationDeg: 0,
          },
          hideExpandedText: false,
          script: [
            {
              id: "arc-1-act-2-page-6-two-vertical-panel-2-beat-1",
              text: "I barely escaped with the Rune Stone.",
              speaker: null,
            },
          ],
        },
      ],
      title: "THE ESCAPE",
      layoutPresetId: "two-vertical",
    },
  ],
  continuePage: {
    id: "arc-1-act-2-continue",
    label: "Continue",
    prompt: "Glyde still has more to tell the team in Quest Hall.",
  },
  entryMode: "previous-page-turn",
};

export default ARC_1_ACT_2_CUT_SCENE;
export { ARC_1_ACT_2_CUT_SCENE };
